import { BsCardList } from "react-icons/bs";
import { LiaToolsSolid, LiaUserFriendsSolid, LiaUsersCogSolid } from "react-icons/lia";
import { PiBookOpenUser } from "react-icons/pi";
import { Outlet, useLocation } from "react-router-dom";
import styled from "styled-components";
import { rootFixedSize } from "styles/theme";
import { MdOutlineTextsms } from "react-icons/md";

const OperationalContainer = styled.section`
  padding: 1rem;
`;
const OperationalWrap = styled.div`
  height: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  background-color: ${(prop) => prop.theme.layer2BgColor};
  border-radius: ${rootFixedSize.containerBorderRadius};
  overflow: hidden;
  .page-title {
    height: 2rem;
    font-size: 1.25rem;
    font-family: var(--font-pretendard-bold);
    padding: 0 0 0.25rem 0.5rem;
    border-bottom: 1px solid ${prop => prop.theme.borderTertiary};
  }
  p {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.5rem;
  }
`;
const OperationalContentTableWrap = styled.article`
  height: calc(100% - 2rem);
  background-color: ${(props) => props.theme.layer2BgColor};
  border-radius: 0.5rem;
  padding: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  overflow: auto;
`;
const titleName = (pathname: string) => {
  if (pathname.includes('/user/list')) {
    return {title: "고객 관리", icon: <LiaUserFriendsSolid />};
  } else if (pathname.includes('/contract')) {
    return {title: "계약관리", icon: <BsCardList />};
  } else if (pathname.includes('/notice')) {
    return {title: "공지사항", icon: <PiBookOpenUser />};
  } else if (pathname.includes('/mgmt')) {
    return {title: "관리자 관리", icon: <LiaUsersCogSolid />};
  } else if (pathname.includes('/after-service')) {
    return {title: "A/S 관리", icon: <LiaToolsSolid />};
  } else if (pathname.includes('/jisa')) {
    return {title: "지사 관리", icon: <LiaToolsSolid />};
  } else if (pathname.includes('/model/recorder')) {
    return {title: "녹화기 모델 관리", icon: <LiaToolsSolid />};
  } else if (pathname.includes('/model/camera')) {
    return {title: "카메라 모델 관리", icon: <LiaToolsSolid />};
  } else if (pathname.includes('/happy-call/send')) {
    return {title: "해피콜 전송", icon: <MdOutlineTextsms />};
  } else if (pathname.includes('/happy-call/template')) {
    return {title: "해피콜 템플릿", icon: <MdOutlineTextsms />};
  } else {
    return {title: "Etc.", icon: null};
  }
};
function Statistics() {

  const { pathname } = useLocation();
  const titleAndIcon = titleName(pathname);
  return (
    <OperationalContainer>
      <OperationalWrap>
        <div className="page-title">
          <p>{titleAndIcon.icon}{titleAndIcon.title}</p>
        </div>
        <OperationalContentTableWrap>
          <Outlet />
        </OperationalContentTableWrap>
      </OperationalWrap>
    </OperationalContainer>
    );
}

export default Statistics;